import { SocialListType } from 'interfaces';

const SOCIAL_LIST: SocialListType[] = [
  {
    NAME: 'LinkedIn',
    LINK: 'https://www.LINKedin.com/in/ivan-klimm-6022461b7',
    ICON: '../../assets/icons/LINKedin.png',
  },
  {
    NAME: 'Facebook',
    LINK: 'https://www.facebook.com/profile.php?id=100002619090545',
    ICON: '../../assets/icons/facebook.png',
  },
  { NAME: 'Telegram', LINK: 'https://t.me/kli2m', ICON: '../../assets/icons/telegram.png' },
  { NAME: 'GitHub', LINK: 'https://github.com/kli2m', ICON: '../../assets/icons/github.png' },
  { NAME: 'VK', LINK: 'https://vk.com/kli2m', ICON: '../../assets/icons/vk.png' },
];

export default SOCIAL_LIST;
